import store from '@/store'

export default [
  {
    path: '/admin/write-offs',
    name: 'write-off',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/write-off/index.vue')
  },
  {
    path: '/admin/write-offs/create',
    name: 'write-off-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/write-off/create.vue')
  },
  {
    path: '/admin/write-offs/:id/show',
    name: 'write-off-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/write-off/show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stock/writeOff/find', to.params.id)
      next()
    }
  },
  {
    path: '/admin/write-offs/:id/edit',
    name: 'write-off-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/write-off/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stock/writeOff/find', to.params.id)
      next()
    }
  }
]
